import { combineReducers } from 'redux'
import userReducer from './userReducer';
import controlReducer from './controleReducer.js';
import UserCurdReducer from './userCrudReducer.js';
import DashboardEquipamentoReducer from './dashboardEquipamentoReducer.js';
import DashboardControlePerdasReducer from './dashboardControlePerdasReducer.js';
import DashboardGeralReducer from './dashboardGeralReducer.js';
import mapReducer from './mapReducer.js';
import HistoricReducer from './historicReducer.js';

const InitialModalState = {
    name: null,
}

const InitialPopupState = {
    name: null,
}

const InitialState = {
    Equipament: null,
}

const InitialStateMenu = {
    visibility: false,
    MenuAling: 'center',
}

function MenuReducer ( PrevState = InitialStateMenu, action){
    switch (action.type) {
        case 'ChangeTextVisibility':
            return{
                ...PrevState,
                visibility: action.payload,
                MenuAling: action.payload ? 'flex-start' : 'center',
            };
        default:
            return PrevState;
    }
}

function ModalReducer ( PrevState = InitialModalState, action){
    switch (action.type) {
        case 'changeModal':
            return{
                ...PrevState,
                name: action.payload.modalName
            };
        default:
            return PrevState;
    }
}

function PopupReducer ( PrevState = InitialPopupState, action){
    switch (action.type) {
        case 'changePopup':
            return{
                ...PrevState,
                name: action.payload.popupName
            };
        default:
            return PrevState;
    }
}

function generalReducer (PrevState = InitialState, action){
    switch (action.type) {
        case 'ChangeEquipament':
            return{
                ...PrevState,
                Equipament: action.payload.Equipament
            };
        default:
            return PrevState;
    }
}

const reducers = combineReducers({userReducer, MenuReducer, generalReducer, controlReducer, ModalReducer, PopupReducer, UserCurdReducer, DashboardEquipamentoReducer, 
    DashboardGeralReducer, mapReducer, HistoricReducer, DashboardControlePerdasReducer});

export { reducers };